import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-9d9557ee")
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "texts p-col-6" }
const _hoisted_3 = { class: "p-col-12 p-p-0" }
const _hoisted_4 = { class: "p-field p-col-12" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Titulo", -1)
const _hoisted_6 = { class: "p-field p-col-12 p-d-flex p-flex-column" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "label" }, "Description", -1)
const _hoisted_8 = { class: "p-field p-col-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { for: "typeformId" }, "Typeform Link", -1)
const _hoisted_10 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "countries" }, "Tags habilitados", -1)
const _hoisted_12 = { class: "accionables p-col-6" }
const _hoisted_13 = { class: "p-field-checkbox p-col-12 p-md-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-mr-3 labels",
  for: "state"
}, "Estado", -1)
const _hoisted_15 = { class: "p-field-checkbox p-col-12 p-md-4" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-mr-3 labels",
  for: "state"
}, "En vivo", -1)
const _hoisted_17 = { class: "p-field-checkbox p-col-12" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "p-mr-3 labels",
  for: "state"
}, "Tipo", -1)
const _hoisted_19 = {
  key: 0,
  class: "p-d-flex p-col-12 p-jc-between"
}
const _hoisted_20 = { class: "p-field p-col-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "from" }, "Empieza el", -1)
const _hoisted_22 = { class: "p-field p-col-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "to" }, "Se muestra el", -1)
const _hoisted_24 = { class: "p-field p-col-12 event-country-selector" }
const _hoisted_25 = { class: "p-col-12" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "countries" }, "Países habilitados", -1)
const _hoisted_27 = { class: "p-field p-col-12" }
const _hoisted_28 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h3", { class: "p-m-0" }, "Speakers del evento", -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" No hay speakers todavía. ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Buscando los speakers que tengamos definidos, en breve se los mostraré. ")
const _hoisted_32 = ["src"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_35 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Nombre", -1)
const _hoisted_37 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Apellido", -1)
const _hoisted_39 = {
  class: "p-field p-col-12 p-md-6",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "file" }, "Seleccione archivo", -1)
const _hoisted_41 = { class: "p-field p-col-12 p-md-6 align-items-center" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "url" }, "O URL", -1)
const _hoisted_43 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "position" }, "Posición", -1)
const _hoisted_45 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "company" }, "Compañía", -1)
const _hoisted_47 = { class: "p-field p-col-12 p-md-6" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "companyImage" }, "Logo Compañía", -1)
const _hoisted_49 = { class: "p-field p-col-12 p-d-flex" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_SelectButton = _resolveComponent("SelectButton")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: "Editor de eventos",
    visible: _ctx.visible,
    "onUpdate:visible": _cache[17] || (_cache[17] = ($event: any) => (_ctx.visible = $event)),
    style: {width: '70vw'}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "Cancelar",
        icon: "pi pi-times",
        onClick: _ctx.closeEditDialog,
        class: "p-button-text "
      }, null, 8, ["onClick"]),
      _createVNode(_component_Button, {
        label: "Guardar",
        icon: "pi pi-check",
        onClick: _ctx.onSave,
        disabled: !_ctx.validData,
        class: ""
      }, null, 8, ["onClick", "disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_InputText, {
                id: "title",
                type: "text",
                modelValue: _ctx.editableEvent.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.editableEvent.title = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Textarea, {
                modelValue: _ctx.editableEvent.description,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.editableEvent.description = $event)),
                autoResize: true,
                rows: "2",
                cols: "30"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputText, {
              id: "typeformId",
              type: "text",
              modelValue: _ctx.editableEvent.typeForm,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.editableEvent.typeForm = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_component_MultiSelect, {
              modelValue: _ctx.editableEvent.tags,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.editableEvent.tags = $event)),
              options: _ctx.tags,
              optionLabel: "name",
              optionValue: "key",
              display: "chip",
              placeholder: "Seleccionar tags"
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_SelectButton, {
              modelValue: _ctx.editableEvent.state,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editableEvent.state = $event)),
              options: _ctx.states,
              optionLabel: "name",
              optionValue: "code"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_SelectButton, {
              modelValue: _ctx.editableEvent.isOnline,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.editableEvent.isOnline = $event)),
              options: _ctx.onlineOptions,
              optionLabel: "name",
              optionValue: "code"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode(_component_SelectButton, {
              modelValue: _ctx.editableEvent.type,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.editableEvent.type = $event)),
              options: _ctx.types,
              optionLabel: "name",
              optionValue: "code"
            }, null, 8, ["modelValue", "options"])
          ]),
          (_ctx.editableEvent.isOnline)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_Calendar, {
                    id: "from",
                    modelValue: _ctx.editableEvent.startDate,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.editableEvent.startDate = $event)),
                    showTime: true,
                    hourFormat: "12",
                    showSeconds: false,
                    showIcon: true,
                    showButtonBar: true
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_Calendar, {
                    id: "to",
                    modelValue: _ctx.editableEvent.visibleDate,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.editableEvent.visibleDate = $event)),
                    showTime: true,
                    hourFormat: "12",
                    showSeconds: false,
                    showButtonBar: true,
                    showIcon: true,
                    minDate: _ctx.editableEvent.startDate
                  }, null, 8, ["modelValue", "minDate"])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              _createVNode(_component_CountrySelector, {
                modelValue: _ctx.editableEvent.countries,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.editableEvent.countries = $event)),
                multiple: true
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createVNode(_component_DataTable, {
            value: _ctx.editableEvent.speakers,
            dataKey: "id",
            rowHover: true,
            globalFilterFields: ['name', 'content'],
            showGridlines: "",
            responsiveLayout: "scroll"
          }, {
            header: _withCtx(() => [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", null, [
                  _createVNode(_component_Button, {
                    icon: "pi pi-plus-circle",
                    label: "Agregar Speaker",
                    class: "p-button-rounded p-button-text p-ml-1 p-button-success",
                    onClick: _ctx.addNewSpeaker
                  }, null, 8, ["onClick"])
                ])
              ])
            ]),
            empty: _withCtx(() => [
              _hoisted_30
            ]),
            loading: _withCtx(() => [
              _hoisted_31
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                header: "Avatar",
                class: "p-text-center",
                field: "avatar"
              }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_component_Avatar, {
                    image: data.avatar,
                    shape: "circle",
                    size: "large"
                  }, null, 8, ["image"])
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                header: "Nombre",
                class: "nombre p-text-center",
                sortable: "",
                field: "name"
              }),
              _createVNode(_component_Column, {
                header: "Apellido",
                class: "p-text-center",
                sortable: "",
                field: "lastName"
              }),
              _createVNode(_component_Column, {
                header: "Posición",
                class: "p-text-center",
                field: "position"
              }),
              _createVNode(_component_Column, {
                header: "Compañia",
                class: "p-text-center",
                field: "company"
              }),
              _createVNode(_component_Column, {
                header: "Logo Compañia (URL)",
                class: "p-text-center",
                field: "companyImage"
              }, {
                body: _withCtx(({data}) => [
                  _createElementVNode("img", {
                    src: data.companyImage,
                    alt: "Image Text"
                  }, null, 8, _hoisted_32)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                headerStyle: "width: 8rem; text-align: center",
                bodyStyle: "text-align: center; overflow: visible"
              }, {
                body: _withCtx(({ data }) => [
                  _createVNode(_component_Button, {
                    type: "button",
                    icon: "pi pi-trash",
                    onClick: ($event: any) => (_ctx.onRemoveSpeaker(data)),
                    class: "p-mr-1"
                  }, null, 8, ["onClick"]),
                  _createVNode(_component_Button, {
                    type: "button",
                    icon: "pi pi-pencil",
                    onClick: ($event: any) => (_ctx.onEditSpeaker(data))
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        (_ctx.showSpeakersAdd)
          ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _hoisted_36,
                  _createVNode(_component_InputText, {
                    id: "name",
                    type: "text",
                    modelValue: _ctx.editableSpeaker.name,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.editableSpeaker.name = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _hoisted_38,
                  _createVNode(_component_InputText, {
                    id: "lastName",
                    type: "text",
                    modelValue: _ctx.editableSpeaker.lastName,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.editableSpeaker.lastName = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createVNode(_component_FileUpload, {
                    class: "ch-fileupload",
                    name: "file",
                    mode: "basic",
                    accept: "image/*",
                    chooseLabel: "Agregar/Editar",
                    customUpload: true,
                    auto: true,
                    onUploader: _ctx.onUpload,
                    onUpload: _ctx.onUploaded
                  }, null, 8, ["onUploader", "onUpload"])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createVNode(_component_InputText, {
                    id: "url",
                    type: "url",
                    modelValue: _ctx.editableSpeaker.avatar,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.editableSpeaker.avatar = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createVNode(_component_InputText, {
                    id: "position",
                    type: "text",
                    modelValue: _ctx.editableSpeaker.position,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.editableSpeaker.position = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_InputText, {
                    id: "company",
                    type: "text",
                    modelValue: _ctx.editableSpeaker.company,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.editableSpeaker.company = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode(_component_InputText, {
                    id: "companyImage",
                    type: "text",
                    modelValue: _ctx.editableSpeaker.companyImage,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.editableSpeaker.companyImage = $event))
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_Button, {
                  label: "Cancelar",
                  icon: "pi pi-times",
                  onClick: _ctx.onCancelNewSpeaker,
                  class: "p-button-text p-mr-6"
                }, null, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  label: "Guardar",
                  icon: "pi pi-check",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onSaveNewSpeaker(_ctx.editableSpeaker))),
                  class: "p-ml-6"
                })
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}